import { Component, OnInit, NgZone } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  chart1: am4charts.XYChart;
  organizationTypeList: any = [];
  signup: any = {}; login: any = {}
  flag: boolean = false;
  orgType: any;
  isLogin: boolean = true;
  showMap: boolean = true;
  team_fun: any = [];
  isCollapsed2;

  constructor(private zone: NgZone, public cstemapi: CstemapiService, private myRoute: Router, public auth: AuthService) {
    if (this.auth.getUserInfo() != '') {
      // if (this.auth.getUserInfo().roleCode == 'gusr') {
      this.myRoute.navigate(['/demo'])
      // }
    }

    this.orgType = 'def';

    this.team_fun = [
      { name: 'Ministry of New and Renewable Energy (MNRE)', role: 'https://mnre.gov.in/', image: 'team/Picture1.png', type: 'R' },
      { name: 'Department of Science and Technology (DST)', role: 'http://dst.gov.in/', image: 'team/Picture2.png', type: 'R' },
      { name: 'Good Energies Foundation', role: 'https://www.goodenergies.org/', image: 'team/Picture3.png', type: 'R' },
      { name: 'International Development Research Centre (IDRC)', role: 'https://www.idrc.ca/en', image: 'team/Picture4.png', type: 'R' },
      { name: 'Oak Foundation', role: 'http://www.oakfnd.org/', image: 'team/Picture5.png', type: 'R' },
      { name: 'National Renewable Energy Laboratory (NREL)', role: 'https://www.nrel.gov/', image: 'team/Picture6.png', type: 'R' }
    ]

    this.login['usrLat'] = '';
    this.login['usrLong'] = '';
  }

  ngOnInit() {
    this.getUserType();

    navigator.geolocation.getCurrentPosition((position) => {
      this.login['usrLat'] = parseFloat(position.coords.latitude.toFixed(2));
      this.login['usrLong'] = parseFloat(position.coords.longitude.toFixed(2));
    });

    this.login['usrRole'] = 'usr'
  }

  getUserType() {
    var dObj = {};
    var api = 'profile/getUserTypeDetails'
    this.cstemapi.cstemAPI(dObj).UserType.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.organizationTypeList = resData.userTypeDetails;
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting user type details!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  organizationTypeChange(otype) {
    this.signup['userTypeId'] = otype.userTypeId;
    this.signup['userTypeCode'] = otype.userTypeCode;
    if (otype.userTypeCode == 'oth') {
      this.flag = true;
    } else {
      this.flag = false;
      this.signup['userTypeOthers'] = '';
    }
  }

  signin() {
    var dObj = this.login;
    var api = 'profile/login';
    this.cstemapi.cstemAPI(dObj).Login.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.auth.saveUserId(resData.userId);
        this.getUserDetails();
        this.cstemapi.enablechart();
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Invalid Credentials!', '', 'error');
      }

      if (resData.statusCode == 'E002') {
        this.cstemapi.Swal.fire({
          title: 'Hey!',
          text: resData.statusMessage,
          type: 'warning',
          confirmButtonText: 'Ok',
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            this.auth.saveUserId(resData.userId);
            this.generateOTP();
          } else {
            this.auth.logout();
            this.myRoute.navigate(['']);
          }
        })
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  newRegister() {
    if (this.orgType == 'def') {
      this.cstemapi.Swal.fire('', 'Please select Role', 'warning');
      return false;
    } else {
      this.signup['loginName'] = this.signup['emailId'];
      this.signup['roleCode'] = 'usr';

      var dObj = this.signup;
      var api = 'profile/registerNewUser'
      this.cstemapi.cstemAPI(dObj).SignUp.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api)
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          this.auth.saveUserId(resData.userId);
          this.generateOTP();
        }
        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire('Error while Signup!', resData.statusMessage, 'error');
        }
        if (resData.statusCode == 'E010') {
          this.cstemapi.Swal.fire('Error while Signup!', resData.statusMessage, 'error');
        }
        if (resData.statusCode == 'E100') {
          this.cstemapi.Swal.fire('Opps..!', resData.statusMessage, 'error');
        }
      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    }
  }

  generateOTP() {
    var dObj = {
      userId: this.auth.getUserId()
    };
    var api = 'profile/generateOtp'
    this.cstemapi.cstemAPI(dObj).GenerateOTP.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.myRoute.navigate(['otp']);
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getUserDetails() {
    var dObj = {
      userId: this.auth.getUserId()
    };
    var api = 'profile/getUserDetails'
    this.cstemapi.cstemAPI(dObj).UserInfo.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.auth.saveUserInfo(resData);
        if (resData.roleCode == 'adm') {
          this.myRoute.navigate(['stats']);
        } else {
          this.myRoute.navigate(['demo']);
        }
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting user details', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  guestLogin() {

    var dObj = {
      usrRole: 'gusr',
      loginName: 'guest@cstep.in',
      pwd: 'Cstem@321',
      usrLat: this.login['usrLat'],
      usrLong: this.login['usrLong']
    }
    var api = 'profile/login'
    this.cstemapi.cstemAPI(dObj).Login.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api)
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.auth.saveUserId(resData.userId);
        this.auth.saveGuestUserId(resData.guestUserId)
        this.getUserDetails();
        this.cstemapi.disablechart();
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Invalid Credentials!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }
}
